module.exports = __webpack_public_path__ + "static/media/BudgetBuddy.70f8b2b5.png";